<template>
  <div
    :itemscope="useSchema"
    :itemtype="useSchema ? 'http://schema.org/ImageObject' : undefined"
    :class="[
      'product-card',
      'js-test-list-de-model',
      'p-card',
      { skeleton: !modelData.id },
      { viewed },
    ]"
    :data-lazy="lazyImg && modelData.id ? modelData.id : null"
    :data-id="!offers && modelData.id ? modelData.id : null"
    :data-rid="modelData && modelData.id"
  >
    <div
      ref="card"
      class="product-card__analytics"
      :data-slot="position"
      :data-url="objToBase64({ url: modelData.view_url })"
      :data-block="blockType"
      :data-type="'offer'"
      :data-offer_id="model.id ? model.id : ''"
      :data-rid="model && model.id"
    />
    <DebugInfo v-if="debugPanel" type="demodel" :data="model" />

    <div v-if="modelData.id" class="product-card__wrapper">
      <div class="product-card__picture-section">
        <UiStickerMonitoring
          v-if="isPercent"
          class="product-card__marker"
          type="percent"
          :text="model.discount.percent"
        />
        <div class="product-card__slider">
          <ui-product-card-slider
            :model="modelData"
            :lazy-img="lazyImg"
            :index="index"
            type="offer"
            block-type="list"
            :position="position"
            :model-path="modelPath"
            :use-schema="useSchema"
            :disabled="isPlaceOrder"
          />
        </div>
        <div class="product-card__icons">
          <ui-ui-button-ico
            icon="favorites"
            size="medium"
            size-ico="24"
            type="tertiary"
            :fill="favorite ? '#363EF8' : 'white'"
            :stroke="favorite ? '#363EF8' : '#86888F'"
            @click.prevent="toggleFavorite"
          />

          <ui-ui-button-ico
            icon="compare"
            size="medium"
            size-ico="24"
            type="tertiary"
            :fill="inCompare ? '#363EF8' : 'white'"
            :stroke="inCompare ? '#363EF8' : '#86888F'"
            @click.prevent.stop="toggleCompare"
          />
        </div>
      </div>
      <div class="product-card__info-description">
        <div
          v-if="isMinPrice"
          class="sticker-monitoring-wrap sticker-monitoring-wrap__mobile"
        >
          <UiStickerMonitoring type="minimal" />
        </div>
        <div class="offer-price">
          <Currency
            v-if="!notInStock && isMobile"
            :value="ProductPrice"
            :link="isMobile ? modelPath : ''"
            class="product-card__price price-s"
          />
          <div v-else-if="isMobile" class="product-card__price price-s">
            Нет в продаже
          </div>
        </div>
        <CpcLink
          :to="model.click_url"
          :offer="model"
          :position="position"
          :block-type="blockType"
          class="product-card__title-link"
          :disabled="isPlaceOrder"
        >
          <div
            class="product-card__title body-l-medium"
            :itemprop="useSchema ? 'name' : undefined"
          >
            {{ modelData.title }}
          </div>
        </CpcLink>
        <div
          v-if="modelData.description || modelSpecification"
          class="product-card__characteristic"
          :itemprop="useSchema ? 'description' : undefined"
        >
          <div class="specifications-curtain" />
          <div class="specifications-wrapper">
            <component
              :is="isMobile ? HorizontalScroll : 'div'"
              class="specifications-container"
            >
              <div class="product-card__visio">
                <ratingMerchant
                  :rating="modelData.rating"
                  :model="modelData"
                  :model-path="modelPath"
                />
                <modelViews :count-views="countViews" is-atom />
              </div>
              <div
                v-for="(spec, ii) in modelSpecification"
                :key="`spec-${ii}`"
                class="specifications body-m-regular"
              >
                <span class="label body-m-regular">{{ spec.title }}: </span>
                <span class="value body-m-regular">{{ spec.value }}</span>
              </div>
            </component>
          </div>
        </div>
        <div class="button-descriptions">
          <ui-ui-link
            v-if="showMoreButton"
            class="button-descriptions"
            icon-before="info-circle"
            size="medium"
            responsive-ico
            :font-weight="400"
            @click="openModal"
          >
            Полное описание
          </ui-ui-link>
        </div>
        <DeliveryInfoCard
          v-if="model.id"
          class="delivery-mobile"
          :model="model"
          @open-info="openModal"
        />
        <div class="l-only-mobile">
          <div v-if="isMobile" class="product-card__buttons">
            <CpcLink
              v-if="!isPlaceOrder"
              class="product-card__button"
              :to="model.click_url"
              :offer="model"
              :position="position"
              :block-type="blockType"
            >
              <ui-ui-button
                mode="div"
                size="medium"
                type="outline"
                font-class="body-m-regular"
                :resize="true"
                responsive-ico
                icon-after="link-external"
              >
                В магазин
              </ui-ui-button>
            </CpcLink>
            <ui-ui-button
              v-else
              :resize="true"
              size="medium"
              type="outline"
              @click="openOrderModal"
            >
              Сделать заказ
            </ui-ui-button>
          </div>
          <div v-if="isMobile" class="product-card__basement">
            <shop-rating :shop="model" class="price-card__basement offer" />
          </div>
        </div>
      </div>
      <div class="product-card__shop-section">
        <div v-if="isMinPrice" class="sticker-monitoring-wrap">
          <UiStickerMonitoring type="minimal" :text="discountMax || 0" />
        </div>
        <div class="offer-price">
          <Currency
            v-if="model"
            type="new"
            :value="ProductPrice"
            prefix=""
            class="product-card__price price-s"
          />
          <Currency
            v-if="isCurrency"
            class="product-card__price-old body-s-strikethrough"
            :value="model.discount.price_before"
          />
        </div>
        <div class="p-card__info-price">
          <cpc-link
            class="p-card__price-self-pickup text-body-s-book"
            :to="model.click_url"
            :offer="model"
            :position="position"
            :block-type="blockType"
            :disabled="isPlaceOrder"
          >
            <ui-delivery-info-b :model="model" is-card />
          </cpc-link>
        </div>
        <div
          class="product-card__buttons"
          :class="{ 'l-mtop-8': showMoreButton }"
        >
          <cpc-link
            v-if="!isPlaceOrder"
            :to="model.click_url"
            :offer="model"
            :position="position"
            :block-type="blockType"
          >
            <ui-ui-button
              mode="div"
              type="outline"
              size="medium"
              :resize="true"
              :loading="!model.id"
              font-class="body-m-regular"
              responsive-ico
              icon-after="link-external"
            >
              В магазин
            </ui-ui-button>
          </cpc-link>
          <ui-ui-button
            v-else
            :resize="true"
            size="medium"
            type="outline"
            :loading="!model.id"
            @click="openOrderModal"
          >
            Сделать заказ
          </ui-ui-button>
        </div>
        <shop-rating :shop="model" class="price-card__basement offer" />
      </div>
    </div>
    <div v-else class="product-card__wrapper">
      <div class="product-card__picture-section">
        <div class="skeleton_img field" />
      </div>
      <div class="product-card__info-description">
        <div class="offer-price field" />
        <div class="product-card__title field" />
        <div v-for="n in 3" :key="`offer-${n}`" class="offer-price field" />
      </div>
      <div v-if="!isMobile" class="product-card__shop-section">
        <div v-for="n in 4" :key="`offer-${n}`" class="offer-price field" />
        <div class="field reg-btn-container" />
      </div>
      <div class="p-card__price" />
    </div>
    <ModalsQuickViewOffer
      v-if="showQuickViewOffer"
      :model="model"
      @close="showQuickViewOffer = false"
      @order="openOrderModal"
    />
  </div>
</template>
<script setup lang="ts">
import shopRating from '~/components/ui/storeRating/storeRatingNotModel.vue';
import HorizontalScroll from '~/components/ui/horizontal-scroll/HorizontalScroll.vue';
import CpcLink from '~/components/ui/CpcLink.vue';
import DebugInfo from '~/components/debug-info/DebugInfo.vue';
import Currency from '~/components/ui/currency/Currency.vue';
import { useFavoriteStore } from '~/stores/favorite';
import { useCompareStore } from '~/stores/compare';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import { useAnalyticsStore } from '~/stores/analytics';
import { useGlobalStore } from '~/stores/global';
import { useInteractiveStore } from '~/stores/interactive';
import modelViews from '~/components/page-model/model-views/ModelViews.vue';
import ratingMerchant from '~/components/ui/rating-merchant/rating-merchant.vue';
import type { ModelOfferItem } from '~/interfaces/api';
import DeliveryInfoCard from '~/components/ui/delivery-info-card/DeliveryInfoCard.vue';
import { useModalsStore } from '~/stores/modals';
import { objToBase64 } from '~/utils/base64';

const props = defineProps({
  model: {
    type: Object as any,
    required: true,
  },
  offers: {
    type: Array,
    required: true,
  },
  lazyImg: {
    type: Boolean,
    default: false,
  },
  nuxtLazy: {
    type: Boolean,
    default: false,
  },
  isBot: {
    type: Boolean,
    default: false,
  },
  viewed: {
    type: Boolean,
    default: false,
  },
  position: {
    type: Number,
    default: 1,
  },
  blockType: {
    type: String,
    default: 'listing',
  },
  useSchema: Boolean,
  addFilterQuery: {
    type: String,
    default: '',
  },
  showMoreButton: {
    type: Boolean,
    default: false,
  },
  index: {
    type: Number,
    default: 0,
  },
  shopRatingHighCount: {
    type: Number,
    default: 0,
  },
  visitCount: {
    type: Number,
    default: 0,
  },
});
const card = ref<HTMLElement | undefined>();
const showButtonMoreOnDesktop = ref(false);
const showQuickViewOffer = ref(false);
const favoriteStore = useFavoriteStore();
const compareStore = useCompareStore();
const mediaStore = useMediaQueryStore();
const analyticsStore = useAnalyticsStore();
const globalStore = useGlobalStore();
const interactiveStore = useInteractiveStore();
const modalsStore = useModalsStore();
const { $ymAnyEvent } = useNuxtApp();
const isFirstInteractive = computed(() => interactiveStore.isFirstInteractive);
const debugPanel = computed(() => globalStore.debugPanel);
const isMobile = computed(() => mediaStore.isMobile);
const modelData = computed(() => ({
  ...props.model.model_info,
  click_url: props.model.click_url,
}));
const discountMax = computed(() => props.model?.model_info?.discount_max || 0);
const cardDescriptionView = ref<boolean>(false);
const cardDescription = ref<HTMLElement>();
const ProductPrice = computed(() => {
  if (modelData.value) {
    return modelData.value?.price_info?.min || '';
  }
  return '';
});

const isPercent = computed<boolean>(
  () =>
    !!props.model &&
    'discount' in props.model &&
    !!props.model.discount &&
    props.model.discount.percent > 0
);
const isMinPrice = computed(() => props.model?.has_min_price);
const modelSpecification = computed(() => {
  return modelData.value?.specifications?.slice(0, 5);
});

const countViews = computed(() => {
  return modelData.value?.visit_count || props.visitCount;
});
// TODO Заменить на протоколы получения данных когда сделают бэк
const merchantRatingCount = 4.5;
// TODO end
const notInStock = computed(() => {
  return !modelData.value.offer_count || null;
});

const inCompare = computed(
  () =>
    modelData.value &&
    compareStore.ids.find(
      (id: number) => Number(id) === Number(modelData.value?.id)
    )
);
const isCurrency = computed<boolean>(
  () =>
    !!props.model &&
    'discount' in props.model &&
    !!props.model.discount?.price_before
);
const modelPath = computed(() => {
  const model = modelData.value;
  if (!model) return '';
  const slug = model?.slug || '';
  if (!props.addFilterQuery) return `/${slug}/`;
  return `/${slug}/?${props.addFilterQuery}`;
});

const favorite = computed(
  () =>
    modelData.value &&
    favoriteStore.ids.find(
      (id: number) => Number(id) === Number(modelData.value?.id)
    )
);
const toggleFavorite = () => {
  if (modelData.value)
    favoriteStore.toggleFavorite({
      id: modelData.value.id,
      catId: +modelData.value.category.id,
      deleteCard: !!favorite.value,
    });
};
const toggleCompare = () => {
  if (modelData.value) {
    compareStore.toggleCompare({
      id: modelData.value.id,
      catId: +modelData.value.category.id,
      deleteCard: !!inCompare.value,
    });
  }
  if (inCompare.value) {
    $ymAnyEvent('reachGoal', 'Compare');
  }
};
const openModal = () => {
  if (props.model) {
    showQuickViewOffer.value = true;
  }
  $ymAnyEvent('reachGoal', 'click_na_opisanie_ot_magazina');
};
const isPlaceOrder = computed(() => props.model?.cpo);
const openOrderModal = () => {
  showQuickViewOffer.value = false;
  modalsStore.setData({
    name: 'order',
    data: {
      offer: props.model,
      position: props.position,
      blockType: props.blockType,
    },
  });
};

onMounted(() => {
  if (cardDescription.value)
    cardDescription.value?.offsetHeight > 42
      ? (cardDescriptionView.value = true)
      : (cardDescriptionView.value = false);
  if (card.value)
    nextTick(() => {
      if (card.value) {
        analyticsStore.observeView(card.value);
      }
      if (!props.isBot) {
        showButtonMoreOnDesktop.value = true;
      }
    });
});
onBeforeUnmount(() => {
  if (card.value) analyticsStore.unobserveView(card.value);
});
</script>
<style
  scoped
  lang="scss"
  src="../productCardListModel/productCardListModelScss.scss"
/>
<style scoped lang="scss">
.offer-price {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  gap: 4px;

  .product-card__price-old {
    overflow: hidden;
    color: $achromatic-disabled;
  }

  @include lg-block {
    gap: 4px;
    margin-bottom: 4px;
  }
  @include xl-block {
    gap: 8px;
    margin-bottom: 4px;
  }
}

.product-card {
  .price-card__basement {
    min-height: 14px;
    margin-top: 4px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    text-align: center;
    @include md-block {
      font-size: 13px;
    }
    @include lg-block {
      min-height: 18px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }

  .price-card__basement {
    &.not-model {
      margin-top: 4px !important;
      align-items: center;
    }

    :deep(.shop-rating) {
      .review-count {
        display: none;
      }
    }
  }
}

.delivery-mobile {
  margin-bottom: 12px;
  @include md-block {
    display: none;
  }
}

.product-card__info-description {
  .product-card__characteristic {
    margin-bottom: 8px;
  }
}

.button-descriptions {
  display: none;
  padding: 4px 8px;
  align-items: center;
  gap: 6px;
  align-self: stretch;
  border-radius: 8px;
  height: 26px;
  background: #f8f8f8;
  justify-content: space-between;
  margin-bottom: 10px;
  cursor: pointer;
  @include md-block {
    display: flex;
    justify-content: initial;
    margin-bottom: 0;
    background: $white;
    margin-top: 12px;
    padding-left: 0;
  }

  &__title {
    color: #363ef8;
    @include lg-block {
      padding-top: 3px;
    }
  }

  &__icon {
    width: 16px;
    height: 16px;
    @include md-block {
      height: 19px;
    }
    @include xl-block {
      width: 18px;
      height: 18px;
    }

    img {
      width: 16px;
      height: 16px;
      @include lg-block {
        width: 20px;
        height: 100%;
      }
    }
  }
}

.p-card__info-price {
  margin-bottom: 8px;
}

.product-card__marker {
  position: absolute;
  top: 4px;
  left: 4px;
  z-index: 2;
  @include lg-block {
    top: 8px;
    left: 8px;
  }
}
</style>
